import { IfPermission } from '@app/core/auth/authorization/components/IfPermission';
import {
  SocialExportPublishSectionHeader,
  socialExportPublishMessages,
} from '@app/modules/social-export/publish';
import { fragmentsPermissions } from '@mi-front/api-clients';
import { QueryView } from '@mi-front/ui';
import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useFragment } from '../../hooks/useFragment';
import { SocialExportPanorama, SocialExportPublishDropdown } from '../social-export-panorama';
import { useFragmentSocialUploadsQuery } from '../social-export-panorama/hooks/useFragmentSocialUploadsQuery';

/**
 * Social export section: permission-gated, only for video stations. Shows section title, publish dropdown and uploads panorama.
 */
export function FragmentSocialPublishView() {
  const { fragment } = useFragment();
  const uploadsQuery = useFragmentSocialUploadsQuery(fragment.id);
  const { $t } = useIntl();

  return (
    <IfPermission permission={fragmentsPermissions.Fragments_SocialPublish}>
      <QueryView query={uploadsQuery} inline>
        {() => (
          <Box>
            <SocialExportPublishSectionHeader
              title={$t(socialExportPublishMessages.sectionTitle)}
              actions={<SocialExportPublishDropdown uploadsByPlatform={uploadsQuery.data} />}
            />
            <SocialExportPanorama uploadsByPlatform={uploadsQuery.data} />
          </Box>
        )}
      </QueryView>
    </IfPermission>
  );
}
